import {
  Code,
  Server,
  Cloud,
  Cpu,
  Lightbulb,
  Shield,
  Award,
  Users,
  Target,
} from "lucide-vue-next";

export const aboutContent = {
  story: {
    title: "Who We Are",
    paragraphs: [
      "At Devolysis, we’re more than just a digital solutions company. We’re a team of passionate creators, problem-solvers, and tech enthusiasts who love building websites and apps that actually make a difference.",

      "We take the time to understand your business, your goals, and your vision, so we can create digital solutions that aren’t just functional—but meaningful. With us, you’re not just getting a service—you’re gaining a partner who truly cares about your success.",
    ],
  },
  expertiseAreas: [
    {
      id: "frontend",
      title: "Frontend Engineering",
      description:
        "Modern frameworks and responsive design that delivers exceptional user experiences across all devices.",
      icon: Code,
    },
    {
      id: "backend",
      title: "Backend Architecture",
      description:
        "Scalable, secure server-side solutions built with best practices and optimized for performance.",
      icon: Server,
    },
    {
      id: "cloud",
      title: "Cloud Infrastructure",
      description:
        "Reliable cloud deployment and management using industry-leading platforms and DevOps practices.",
      icon: Cloud,
    },
    {
      id: "ai-ml",
      title: "AI/ML Integration",
      description:
        "Intelligent automation and machine learning solutions that enhance capabilities and drive innovation.",
      icon: Cpu,
    },
    {
      id: "product-strategy",
      title: "Product Strategy",
      description:
        "Strategic planning and roadmap development that aligns technology with business objectives.",
      icon: Lightbulb,
    },
    {
      id: "security",
      title: "DevOps & Security",
      description:
        "Continuous integration, deployment automation, and security best practices for robust applications.",
      icon: Shield,
    },
  ],
  philosophy: [
    {
      id: "quality",
      title: "Quality Over Quantity",
      description:
        "We take on fewer projects to ensure exceptional results for every client. Our selective approach allows us to invest the time and expertise needed to deliver truly transformative solutions.",
      icon: Award,
    },
    {
      id: "partnership",
      title: "Strategic Partnerships",
      description:
        "We view our client relationships as long-term partnerships. Your success is our success, and we're committed to being a trusted advisor throughout your digital journey.",
      icon: Users,
    },
    {
      id: "impact",
      title: "Meaningful Impact",
      description:
        "Every project we undertake is driven by a focus on measurable business outcomes. We don't just build software—we create solutions that drive growth and solve real problems.",
      icon: Target,
    },
  ],
};
